module.exports = __webpack_public_path__ + "img/visa.892d84a.svg";